export default __webpack_public_path__ + "static/media/sp-3.c770d8d0.png";